module.exports = __webpack_public_path__ + "images/help/logo-6fde994c9916c27c9ce5a0f4d1cadf14.png";